import Logger from "neon-frontend-utils/src/logger";
import AppConfig from "../../../App.config";
import Components from "../../../constants/Components";
import RedirectRenderer from "../../../utils/RedirectRenderer";
import * as actionType from "../constants/ActionTypes";
import UserLanguageLocalStorage from "../constants/UserLanguageLocalStorage";

const localStorageValue = localStorage.getItem(UserLanguageLocalStorage.USER_LANGUAGE);
let language = AppConfig.languages.defaultLanguageId;

if (localStorageValue) {
    if (AppConfig.languages.supported.includes(localStorageValue)) {
        // use locally stored language id instead of the application default
        language = localStorageValue;
    }
}

const initialState = {
    languageId: language,
};

/**
 * Returns the new state
 * @param {Object} state - state
 * @param {Object} action - action
 * @returns {Object} new state
 */
export default function switchLanguageReducer(state = initialState, action) {
    const newState = Object.assign({}, state);

    switch (action.type) {
        case actionType.SWITCH_LANGUAGE:
            try {
                // persist in store
                newState.languageId = action.languageId;

                // refresh the page in the language that was switched to
                RedirectRenderer.render(window.location.pathname, true, null);
            } catch (error) {
                Logger.instance.error({
                    component: Components.PROFILE,
                    error,
                    message: "Exception in switchLanguageReducer",
                });
            }

            break;

        default:
            return state;
    }

    return newState;
}
